import { render, staticRenderFns } from "./TransferHistoryList.vue?vue&type=template&id=0425ef93&scoped=true"
import script from "./TransferHistoryList.vue?vue&type=script&lang=js"
export * from "./TransferHistoryList.vue?vue&type=script&lang=js"
import style0 from "./TransferHistoryList.vue?vue&type=style&index=0&id=0425ef93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0425ef93",
  null
  
)

export default component.exports